import { Outlet } from "react-router-dom";
import { LandingRedirect } from "@/lib/rbac/landing";

export default function AuthLayout() {
  const token = localStorage.getItem("access_token");

  // Already logged in -- bounce to the user's best landing page (not
  // always /dashboard; leads end up at /departments, RBAC admins at
  // /rbac, etc. depending on their permissions).
  if (token) {
    return <LandingRedirect />;
  }

  return (
    <div className="min-h-screen">
      <Outlet />
    </div>
  );
}
